import React from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext.js';


import MessageSnackBar from './MessageSnackBar.js';
import WarehouseIcon from '@mui/icons-material/Warehouse';

import AdminGrid from './AdminGrid.js';
import LocationGrid from './LocationGrid.js';
import { 
    Button, 
    Grid,
    Paper, 
  } from '@mui/material';
import { width } from '@mui/system';
import { render } from '@testing-library/react';



const LocationMetrics = (props) => {
    //SECTION USER CONTEXT and HEADERS
    const userData = useContext(UserContext);
    const storedHeaders = sessionStorage.getItem('headers');
    const headers = storedHeaders ? JSON.parse(storedHeaders) : {};
    // !SECTION

    //SECTION Message Bar Controls
      const [ messageBarMessage, setMessageBarMessage ] = React.useState('');
      const [ messageBarOpen, setMessageBarOpen ] = React.useState(false);
      const [ messageSeverity, setMessageSeverity ] = React.useState('success');
      const handleMessageBarClosing = () => {
        setMessageBarOpen(false);
      };
      //!SECTION

    //SECTION Component Controls
    const itemMessage = 'Location Metrics';
    const toggleItems = () => {
      if (viewItems){
          setViewItems(false);
          setViewItemsMessage(`${itemMessage}`);
          // console.log("user data", userData.name)
      }else{
          // getWarehouseList(userData.email)
          setViewItems(true);
          setViewItemsMessage(`Hide ${itemMessage}`);
      };
  } ;
    const [ viewItems, setViewItems ] = React.useState(false);
    const [ viewItemsMessage, setViewItemsMessage ] = React.useState(`View ${itemMessage}`);

    //!SECTION





    //SECTION - Data Fetching 

    React.useEffect(() => {
        getDNIStats(userData.email);
        getOrderDiscrepanciesStats(userData.email);
        getNoASNStats(userData.email);
    }, []);


    //SECTION - DNI by location

    const [ gridDNIData, setGridDNIData ] = React.useState([]);
    const wrapHeader = (headerName) => (
      <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'center' }}>
        {headerName}
      </div>
    );
    // // const [ visibleColumns, setVisibleColumns ] = React.useState([]);

    const gridDNIColumns =  [
      {field: 'id', headerName: 'Location Number',  editable: false, headerAlign: 'center', align: 'center',  type:'number', width: 75, renderHeader: () => wrapHeader('No Inbound')},
      {field: 'locationName', headerName: 'Location Name', headerAlign: 'center', align: 'center',  editable: false, width: 300, renderHeader: () => wrapHeader('Location Name')},
      {field: 'count', headerName: 'No Inbound', headerAlign: 'center', align: 'center',  editable: false, flex: 1, renderHeader: () => wrapHeader('Delivered No Inbound')},
      ]

    const getDNIStats = async (user) => {
      var parameters = { accountcode: userData.accountCode}; 

      await axios
      .get(
          `/Metrics/dnibylocation`,
          { headers: headers, params: parameters }
          )
          .then(function async(response) {
            // console.log("DNI", response.data.message)
            setGridDNIData(response.data.message)
          })
          .catch(function (error) {
          if (error.response.status === 401) {
              alert ("Your session has expired. Please login again.");
  
          }
          if (error.response.status !== 401) {
              setMessageBarMessage(`${error.response.data.detail}  Something went wrong. Contact info@edonconnect.tech for help.`);
              setMessageBarOpen(true);
              setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
          })
      };
    // !SECTION- DNI by location


    //SECTION - DNI by location

    const [ gridNoASNData, setGridNoASNData ] = React.useState([]);
    // // const [ visibleColumns, setVisibleColumns ] = React.useState([]);

    const gridNoASNColumns =  [
      {field: 'id', headerName: 'Warehouse Number',  editable: false, headerAlign: 'center', align: 'center',  type:'number', width: 100, renderHeader: () => wrapHeader('Warehouse Number')},
      {field: 'locationName', headerName: 'Location Name', headerAlign: 'center', align: 'center',  editable: false, width: 275, renderHeader: () => wrapHeader('Location Name')},
      {field: 'count', headerName: 'Inbound No ASN', headerAlign: 'center', align: 'center',  editable: false, flex: 1, renderHeader: () => wrapHeader('Inbound No ASN')},
      ]

    const getNoASNStats = async (user) => {
      var parameters = { accountcode: userData.accountCode}; 

      await axios
      .get(
          `/Metrics/inboundNoASNbylocation`,
          { headers: headers, params: parameters }
          )
          .then(function async(response) {
            // console.log("DNI", response.data.message)
            setGridNoASNData(response.data.message)
          })
          .catch(function (error) {
          if (error.response.status === 401) {
              alert ("Your session has expired. Please login again.");
  
          }
          if (error.response.status !== 401) {
              setMessageBarMessage(`${error.response.data.detail}  Something went wrong. Contact info@edonconnect.tech for help.`);
              setMessageBarOpen(true);
              setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
          })
      };
    // !SECTION- DNI by location









    //SECTION - Order Discrepancies by location

    const [ gridOrdeDiscreapanciesData, setGridOrderDiscrepanciesData ] = React.useState([]);
    // // const [ visibleColumns, setVisibleColumns ] = React.useState([]);
    const gridOrderDiscreapanciesColumns =  [
      {field: 'id', headerName: 'Ship To Number', hide:true, editable: false, headerAlign: 'center', align: 'center',  type:'number', width: 100,renderHeader: () => wrapHeader('Ship To Number')},
      // {field: 'Ship To Number', headerName: 'Ship To Number', headerAlign: 'center', align: 'center',  editable: false, width: 325},
      {field: 'Ship To Name', headerName: 'Ship To Name', headerAlign: 'center', align: 'center',  editable: false, width: 275,renderHeader: () => wrapHeader('Ship To Name')},
      {field: 'count', headerName: 'In Stock', headerAlign: 'center', align: 'center',  editable: false, flex: 1, renderHeader: () => wrapHeader('In Stock')},
      ]

    const getOrderDiscrepanciesStats = async (user) => {
      var parameters = { accountcode: userData.accountCode}; 

      await axios
      .get(
          `/Metrics/orderdiscrepanciesbylocation`,
          { headers: headers, params: parameters }
          )
          .then(function async(response) {
            // console.log("Order Discrepancies", response.data.message)

            setGridOrderDiscrepanciesData(response.data.message)
            // setGridOrderDiscrepanciesData (response.data.message)
          })
          .catch(function (error) {
          if (error.response.status === 401) {
              alert ("Your session has expired. Please login again.");
  
          }
          if (error.response.status !== 401) {
              setMessageBarMessage(`${error.response.data.detail}  Something went wrong. Contact info@edonconnect.tech for help.`);
              setMessageBarOpen(true);
              setMessageSeverity("error") // error: red, warning: orange, information: blue, success: green
          }
          })
      };
    // !SECTION- Order Discrepancies by location



  return (  

      <>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ alignContent: "center", border: 0 }}
      >
        <Paper
          sx={{ p: 1, display: "flex", flexDirection: "column" }}
        >
          <Button 
          onClick={toggleItems}
          startIcon={<WarehouseIcon size="large" />}
          >
            {" "}
            {viewItemsMessage}
          </Button>

          {/* Component Items */}
          {viewItems &&
          <>
          <MessageSnackBar messageBarMessage={messageBarMessage} messageBarOpen={messageBarOpen} handleMessageBarClosing={handleMessageBarClosing} messageSeverity={messageSeverity} /> 
          
          {/* <Grid container direction="row" marginTop={5} marginBottom={5} sx={{justifyContent: "space-between", border:1, borderStyle: 'dotted', borderRadius: '5px'  }}> */}
          <Grid
            container
            marginTop={5}
            sx={{
              justifyContent: "space-between",
              alignContent: "flex-start",
              p: 1,
              border: 0,
              borderStyle: "dotted",
              borderRadius: "5px",
              overflow: 'hidden'
            }}
          >
 

          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{  
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            border: 1,
            borderStyle: "dotted",
            borderRadius: "5px",
            margin: 0

            }}
          >
            <LocationGrid gridColumns={gridDNIColumns} gridData={gridDNIData} gridTitle={"Delivered No Inbound"} />
          </Grid>   

          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{  
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            border: 1,
            borderStyle: "dotted",
            borderRadius: "5px",
            margin: 0

            }}
          >
            <LocationGrid gridColumns={gridNoASNColumns} gridData={gridNoASNData} gridTitle={"Inbound No ASN"} />
          </Grid>     


          <Grid
          item
          xs={4}
          md={4}
          lg={4}
          sx={{  
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            border: 1,
            borderStyle: "dotted",
            borderRadius: "5px",
            margin: 0

            }}
          >
            <LocationGrid gridColumns={gridOrderDiscreapanciesColumns} gridData={gridOrdeDiscreapanciesData} gridTitle={"Order Discrepancies"} />
          </Grid>       

                    


          </Grid>
        </>
    }
        </Paper>
      </Grid>
  </>


  );
};
export default LocationMetrics;